export default __webpack_public_path__ + "static/SharpGroteskBold15-Regular-5048bd08d57748fd1e39f6c572052d04.woff";